import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageContainer = styled.div`
  width: 430px;
  img {
    width: 100%;
    padding-right: 30px;
  }
`;

export const MessageContainer = styled.div`
  padding-left: 50px;
  font-family: sans-serif;
  h1 {
    font-size: 70px;
    font-weight: 900;
    margin: 15px 0px;
  }
  h2 {
    font-weight: 700;
  }
  p {
    font-size: 16px;
    line-height: 25px;
    margin-bottom: 30px;
  }
  a {
    background: #ff3a59;
    outline: none;
    border: none;
    padding: 10px 35px;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;
    font-family: sans-serif;
    font-weight: 400;
    text-decoration: none !important;
    &:hover {
      color: #fff;
    }
  }
`;
